import * as actions from "./network.actions";

export interface State {
    online: boolean;
    authenticated: boolean;
}

export const initialState: State = {
    online: false,
    authenticated: false
};

export function reducer(state = initialState, action: actions.Actions): State {
    switch (action.type) {
        case actions.SET_ONLINE: {
            return {
                ...state,
                online: action.payload
            };
        }
        case actions.SET_AUTHENTICATED: {
            return {
                ...state,
                authenticated: action.payload
            };
        }
        case actions.SET_ONLINE_AND_AUTHENTICATED: {
            return {
                ...state,
                online: action.online,
                authenticated: action.authenticated
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/core/business-objects/network/network.reducer.ts